export const RIDE_PHASE = {
  WAITING_PAYMENT: 'WAITING_PAYMENT',
  WAITING_VENDOR: 'WAITING_VENDOR',
  VENDOR_ASSIGNED: 'VENDOR_ASSIGNED',
  CAR_ASSIGNED: 'CAR_ASSIGNED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

const hasId = (value) => value != null && String(value).trim() !== '' && String(value) !== '0';

export const hasAssignedVendor = (ride) => hasId(ride?.vendorId);
export const hasAssignedCar = (ride) => hasId(ride?.carId);
export const hasAssignedDriver = (ride) => hasId(ride?.driverId);

export const requestedVehicle = (ride) => ride?.packageCarModel || '';

export const ridePhaseOf = (ride) => {
  if (!ride) return '';
  const phase = String(ride.ridePhase || '').toUpperCase();
  if (Object.values(RIDE_PHASE).includes(phase)) {
    return phase;
  }

  const status = String(ride.status || '').toUpperCase();
  const method = String(ride.paymentMethod || '').toUpperCase();
  const pay = String(ride.paymentStatus || '').toUpperCase();

  if (status === 'CANCELLED') return RIDE_PHASE.CANCELLED;
  if (status === 'COMPLETED') return RIDE_PHASE.COMPLETED;
  if (hasAssignedCar(ride)) return RIDE_PHASE.CAR_ASSIGNED;
  if (hasAssignedVendor(ride)) return RIDE_PHASE.VENDOR_ASSIGNED;
  if (method === 'ONLINE' && pay === 'PENDING') {
    return RIDE_PHASE.WAITING_PAYMENT;
  }
  return RIDE_PHASE.WAITING_VENDOR;
};

export const rideTabOf = (phase) => {
  if (phase === RIDE_PHASE.WAITING_PAYMENT) return 'WAITING';
  if (phase === RIDE_PHASE.WAITING_VENDOR || phase === RIDE_PHASE.VENDOR_ASSIGNED || phase === RIDE_PHASE.CAR_ASSIGNED) {
    return 'UPCOMING';
  }
  if (phase === RIDE_PHASE.COMPLETED) return 'PAST';
  if (phase === RIDE_PHASE.CANCELLED) return 'CANCELLED';
  return 'ALL';
};

export const rideBadge = (ride) => {
  const phase = ridePhaseOf(ride);
  if (phase === RIDE_PHASE.WAITING_PAYMENT) return 'Waiting for payment';
  if (phase === RIDE_PHASE.WAITING_VENDOR) return 'Vendor will be assigned';
  if (phase === RIDE_PHASE.VENDOR_ASSIGNED) return ride.vendorName || 'Vendor assigned';
  if (phase === RIDE_PHASE.CAR_ASSIGNED) return 'Upcoming';
  if (phase === RIDE_PHASE.COMPLETED) {
    if (String(ride.paymentMethod || '').toUpperCase() === 'CASH'
      && String(ride.paymentStatus || '').toUpperCase() === 'PENDING') {
      return 'Pay now';
    }
    return 'Completed';
  }
  if (phase === RIDE_PHASE.CANCELLED) return 'Cancelled';
  return phase || 'Unknown';
};

export const needsOnlinePayNow = (ride) => ridePhaseOf(ride) === RIDE_PHASE.WAITING_PAYMENT;

export const needsCompletedCashPay = (ride) => (
  ridePhaseOf(ride) === RIDE_PHASE.COMPLETED
  && String(ride.paymentMethod || '').toUpperCase() === 'CASH'
  && String(ride.paymentStatus || '').toUpperCase() === 'PENDING'
);

export const sortRidesNewest = (rides) => (
  [...rides].sort((left, right) => {
    const leftTime = new Date(left.createdAt || left.carRequestTime || 0).getTime();
    const rightTime = new Date(right.createdAt || right.carRequestTime || 0).getTime();
    return rightTime - leftTime;
  })
);

export const customerRideSections = (groups = {}) => ({
  WAITING: sortRidesNewest(groups.created || []),
  UPCOMING: sortRidesNewest([
    ...(groups.confirmed || []),
    ...(groups.vendorAssigned || []),
    ...(groups.carAssigned || [])
  ]),
  PAST: sortRidesNewest(groups.completed || []),
  CANCELLED: sortRidesNewest(groups.cancelled || [])
});

export const mergeRideGroups = (groups = {}) => {
  const sections = customerRideSections(groups);
  return sortRidesNewest([
    ...sections.WAITING,
    ...sections.UPCOMING,
    ...sections.PAST,
    ...sections.CANCELLED
  ]);
};
